import { ValidatorService } from './tools/validator.service';
import { AutenticacionService } from './autenticacion.service';
import { Http, ResponseContentType } from '@angular/http';
import { ConstantsService } from './constants.service';
import { Injectable } from '@angular/core';
import { ErrorsService } from './tools/errors.service';
declare var $;

@Injectable()
export class PlazosService {

  private service_url;
  constructor(private constantsService: ConstantsService, private http: Http, private authService: AutenticacionService, private validatorService: ValidatorService, private errorService: ErrorsService) {
    this.service_url = this.constantsService.apiURL + '/catalogos/plazos';
  }

  getDefaultSchedule() {
    return {"id" : "", "nombre": ""};
  }

  getDefaultScheduleArray() {
    return [ {"id" : "", "nombre": ""}];
  }

  public get(page = null, limit = 10, tipo_credito = null, select = '') {
    var url_filtros = '';
    if (page) {
      return this.http.get(this.service_url + '?paginate=true&limit='+ limit +'&page=' + page , this.authService.getAuthHeaders());
    }
    if(tipo_credito !== null)
      url_filtros = '&tipo_credito=' + tipo_credito;

    return this.http.get(this.service_url + '?select=' + select + url_filtros, this.authService.getAuthHeaders());
  }

  public getAll(tipo_credito) {
    let service = this.service_url + '?select=""';
    if(tipo_credito){
      service += '&tipo_credito=' + tipo_credito;
    }

    return this.http.get(service, this.authService.getAuthHeaders());
  }

  public writePermission() {
    return true;
    //return this.authService.hasPermission(10, true);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/plazos.service.ts